import type { MeResponse, PortalLead, PortalStore, PortalUser } from "./api";

export const mockStores: PortalStore[] = [
  {
    id: "11111111-1111-4111-8111-111111111111",
    slug: "serra-negra-matriz",
    name: "Loja matriz X-Bolo",
    partner: "Loja matriz X-Bolo",
    city: "Serra Negra",
    state: "SP",
    status: "available",
    storeStatus: "active",
    profileType: "official_store",
    profileLabel: "Loja autorizada",
    phone: "(19) 2152-6116",
    whatsapp: "551921526116",
    contactUrl: "https://wa.me/551921526116",
    instagramUrl: "https://www.instagram.com/xbolo_oficial/",
    orderUrl: "https://xbolo.kyte.site",
    orderLabel: "Fazer pedido",
    mapsUrl: "",
    serviceNote: "",
    dineInAvailable: false,
    pickupAvailable: false,
    onlineOrderAvailable: true,
    certificate: {
      code: "xb_demo_public_code",
      status: "active",
      title: "Loja verificada X-Bolo original",
      verificationUrl: "https://xbolo.com/verificacao/?c=xb_demo_public_code"
    },
    users: [
      {
        id: "user-1",
        email: "parceiro@xbolo.local",
        name: "Parceiro Demo",
        role: "owner",
        linkStatus: "active"
      }
    ],
    hours: [
      { dayOfWeek: 0, closed: true, note: "Fechado" },
      { dayOfWeek: 1, opensAt: "10:00", closesAt: "18:00" },
      { dayOfWeek: 2, opensAt: "10:00", closesAt: "18:00" },
      { dayOfWeek: 3, opensAt: "10:00", closesAt: "18:00" },
      { dayOfWeek: 4, opensAt: "10:00", closesAt: "18:00" },
      { dayOfWeek: 5, opensAt: "10:00", closesAt: "18:00" },
      { dayOfWeek: 6, opensAt: "10:00", closesAt: "18:00" }
    ]
  }
];

export const mockLeads: PortalLead[] = [
  {
    id: "lead-1",
    type: "consumer_waitlist",
    name: "Ana Consumidora",
    phone: "(11) 99999-0000",
    email: "",
    city: "Sao Paulo",
    state: "SP",
    instagram: "",
    status: "new",
    createdAt: new Date().toISOString(),
    message: "Quero provar quando chegar na cidade."
  },
  {
    id: "lead-2",
    type: "pro_application",
    name: "Bruna Confeiteira",
    phone: "(19) 98888-0000",
    email: "bruna@example.com",
    city: "Campinas",
    state: "SP",
    instagram: "@brunadoces",
    status: "contacted",
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    message: "Ja vendo doces e quero entrar na comunidade."
  }
];

export const mockUsers: PortalUser[] = [
  {
    id: "mock-user-1",
    cognitoSub: "mock-partner-sub",
    email: "parceiro@xbolo.local",
    name: "Parceiro Demo",
    globalRole: "partner",
    status: "active",
    cognitoStatus: "CONFIRMED",
    cognitoEnabled: true,
    inviteSentAt: new Date(Date.now() - 172800000).toISOString(),
    inviteResentAt: null,
    lastCognitoSyncAt: new Date().toISOString(),
    lastInviteError: "",
    lastLoginAt: new Date(Date.now() - 3600000).toISOString(),
    createdAt: new Date(Date.now() - 172800000).toISOString(),
    updatedAt: new Date().toISOString(),
    storeLink: {
      id: "mock-link-1",
      storeId: mockStores[0].id,
      storeSlug: mockStores[0].slug,
      storeName: mockStores[0].name,
      city: mockStores[0].city,
      state: mockStores[0].state,
      role: "owner",
      status: "active"
    }
  }
];

export function mockMe(admin = true): MeResponse {
  return {
    user: {
      id: admin ? "mock-admin" : "mock-partner",
      email: admin ? "admin@xbolo.local" : "parceiro@xbolo.local",
      name: admin ? "Admin X-Bolo" : "Parceiro X-Bolo",
      role: admin ? "admin" : "partner",
      status: "active"
    },
    permissions: {
      admin,
      partner: true
    },
    stores: mockStores
  };
}
